import { MeteosolAuthGuard } from './meteosol-auth-guard.service';
import { DummyAuthGuard } from './dummy-auth.guard';
import { environment } from '../../environments/environment';

export const AUTH_GUARD = environment.auth.use_dummy_auth ? DummyAuthGuard : MeteosolAuthGuard;
